import { render, staticRenderFns } from "./PlantCodeMaintain.vue?vue&type=template&id=63cff6eb&scoped=true"
import script from "./PlantCodeMaintain.vue?vue&type=script&lang=js"
export * from "./PlantCodeMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cff6eb",
  null
  
)

export default component.exports